<template>
    <a class="button button-default size-24-600"
       :href="!link || link === '#' ? 'https://www.prometheuspro.us/main_home' : link"
       target="_blank"
    >
        {{ text }}
    </a>
</template>

<script>
export default {
    name: "ButtonBookDemo",
    props: {
        link: String,
    },
    data() {
        return {
            title: {
                en: "Book a Demo",
                es: "Book a Demo",
                pt: "Book a Demo"
            },
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale
        },
        text() {
            return this.title[this.lang]
        }
    }
}
</script>

<style scoped>

</style>